/**
 * @desc listWithDetails
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/allocation/listWithDetails`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
